export default function Separator() {
  return <div className="bg-slate-500 h-0.5 w-full my-[5rem] lg:my-[10rem]" />;
}
